export default "__VITE_ASSET__ghtlA1XN__"